export interface KPIThresholdConfig {
	Name: string;
	MaxValue: number;
	Red: number;
	Orange: number;
	Yellow: number;
	GreenSoft: number;
	GreenNormal: number;
	GreenHard: number;
}

export interface ShiftReportConfig {
	Thresholds: KPIThresholdConfig[];
}

export const TIME_LEFT_KPI_NAME = "Time Left";

const DEFAULT_THRESHOLD = (name: string): KPIThresholdConfig => ({
	Name: name,
	MaxValue: 100,
	Red: 0,
	Orange: 40,
	Yellow: 60,
	GreenSoft: 75,
	GreenNormal: 85,
	GreenHard: 95,
});

const DEFAULT_TIME_LEFT_THRESHOLD = (): KPIThresholdConfig => ({
	Name: TIME_LEFT_KPI_NAME,
	MaxValue: 96,
	Red: 0,
	Orange: 2,
	Yellow: 6,
	GreenSoft: 12,
	GreenNormal: 24,
	GreenHard: 48,
});

const ZONE_ORDER: (keyof Omit<KPIThresholdConfig, "Name" | "MaxValue">)[] = [
	"Red",
	"Orange",
	"Yellow",
	"GreenSoft",
	"GreenNormal",
	"GreenHard",
];

export const validateThresholds = (
	thresholds: KPIThresholdConfig[],
): Record<string, string> => {
	const errors: Record<string, string> = {};
	for (const t of thresholds) {
		const usesMaxValue = t.Name === TIME_LEFT_KPI_NAME;
		for (let i = 1; i < ZONE_ORDER.length; i++) {
			const currZone = ZONE_ORDER[i];
			const prevZone = ZONE_ORDER[i - 1];
			if (t[currZone] < 0) {
				errors[`${t.Name}.${currZone}`] = "Must be >= 0";
			} else if (!usesMaxValue && t[currZone] > 100) {
				errors[`${t.Name}.${currZone}`] = "Must be between 0 and 100";
			} else if (usesMaxValue && t[currZone] > t.MaxValue) {
				errors[`${t.Name}.${currZone}`] = `Must be <= MaxValue (${t.MaxValue})`;
			} else if (t[currZone] < t[prevZone]) {
				errors[`${t.Name}.${currZone}`] =
					`Must be >= ${prevZone} (${t[prevZone]})`;
			}
		}
	}
	return errors;
};

export const INCENTIVE_KPI_NAME = "Incentive";
const DEFAULT_INCENTIVE_THRESHOLD = (): KPIThresholdConfig => ({
	Name: INCENTIVE_KPI_NAME,
	MaxValue: 100,
	Red: 0,
	Orange: 20,
	Yellow: 40,
	GreenSoft: 60,
	GreenNormal: 80,
	GreenHard: 100,
});

export const SHIFT_REPORT_CONFIG_INITIAL_VALUES: ShiftReportConfig = {
	Thresholds: [
		DEFAULT_THRESHOLD("TPH"),
		DEFAULT_THRESHOLD("Uptime"),
		DEFAULT_THRESHOLD("PushRate"),
		DEFAULT_THRESHOLD("Productivity"),
		DEFAULT_INCENTIVE_THRESHOLD(),
		DEFAULT_TIME_LEFT_THRESHOLD(),
	],
};
